import { Component, Input, OnInit, ViewChild } from "@angular/core";
import Course from "../../models/course.model";
import { ProfileService } from "../../services/profile.service";

@Component({
  selector: "ngx-view-course-info",
  styleUrls: ["./view-course-info.component.scss"],
  templateUrl: "./view-course-info.component.html",
})
export class ViewCourseInfoComponent implements OnInit {
  @Input() course = new Course();
  @Input() trees: Set<string> = new Set([]);
  @Input() mode?: string = "student";
  @Input() courseId?: string = "";

  submitted = false;
  loading = false;

  constructor(private profileApi: ProfileService) {}

  ngOnInit() {}
}
